<template>
<div>
    <v-main>
        <div>
            <v-card flat class="ma-2">
                <v-row cols="12" no-gutters class="mb-4 ml-8">
                    <v-col cols="5">
                        <h2>{{this.title}}</h2>
                    </v-col>
                </v-row>
                <v-row cols="12" class="ma-4">
                    <!-- <v-container> -->
                            <div style="height: 500px; width: 100%;">
                                <canvas id="prognose1" height="500" style="width:100%;"></canvas>
                            </div>
                    <!-- </v-container> -->
                </v-row>
            </v-card>   
            <div class="ml-8">Bookings previous years</div>   
            <div><p/></div>
            <div style="display: flex; flex-direction: row;" class="ml-8">
                <div style="width: 100px;">Bookings</div>{{ this.year1 }}  
                <div class="ml-3">{{ this.year1b }}</div>                           
            </div>
            <div style="display: flex; flex-direction: row;" class="ml-8">
                <div style="width: 100px;">Bookings </div> {{ this.year2 }}
                <div class="ml-3">{{ this.year2b }}</div>
                <div class="ml-3">{{this.incdec}}{{ this.perc1 }}%</div>
            </div>            
            <div><p/></div>
            <div class="ml-8">Bookings last 14 days</div>
            <div><p/></div>
            <div style="display: flex; flex-direction: row;" class="ml-8">
                <div style="width: 100px;">Bookings</div>{{ this.year2 }}  
                <div class="ml-3">{{ this.bprev}}</div>                           
            </div>
            <div style="display: flex; flex-direction: row;" class="ml-8">
                <div style="width: 100px;">Bookings </div> 2024
                <div class="ml-3">{{this.bnow}}</div>
                <div class="ml-3">{{this.incdec}}{{ this.perc2 }}%</div>
            </div>                  
        </div>   
    </v-main>    
    <div>
        <navBar title="Ares - Customer Success" :home="true" type="customersuccess" goto="/task/customer_success/mnCustomerSuccess" />
    </div>
</div>        
</template>

<script>

import navBar from "@/components/ui/navbars/navbar.vue";
import mxbookingschart from '@/views/syst/dashboard/mixins/bookings_chart_v8';

import { Chart, registerables } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
Chart.register(...registerables, ChartDataLabels); // registered globally

export default {
    data() {
        return {
            loading: false,
            title: "4-week booking prognosis",
            bookingsTY: [],
            bookingsPY: [],
            bookingsPrg: [], 
            chart: null,            
            year1: '',
            year2: '',
            year1b: '',
            year2b: '',
            incdec: '+',
            bnow: '',
            bprev: '',
            perc1: '',
            perc2: '',
            perc3: ''
        }
    },
    mixins:[mxbookingschart],
    components: {
        navBar,
    },       
    created(){ // set up event bus listener here on created event
        this.getData('load');
    },         
    mounted() {

    },    
    methods: {
        refreshChart(object){
            this.chart.data.labels = object.data.labels;
            let i = 0;
            this.chart.data.datasets.forEach((dataset) => {
                dataset.data = object.data.datasets[i].data;
                i++;
            });
            this.chart.options = object.options;
            this.chart.update();
        },        
        getData(param) {
            this.$axios
                    .post("ares/json/ares/task/customer_success/bdiag/getBookingDiagnosisv2.p", { 
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "getDiagnosis"
                        }
                    })
                    .then(res => {
                        if (res.data.error) {
                            console.log(res.data.error);
                        } else {
                            // console.log(JSON.stringify(res.data.getRecentBookingsThisYear));
                            // console.log(JSON.stringify(res.data.getRecentBookingsPreviousYear));
                            // console.log(JSON.stringify(res.data.getRecentBookingsPrognosis));
                            this.bookingsTY = res.data.getRecentBookingsThisYear;    
                            this.bookingsPY = res.data.getRecentBookingsPreviousYear;  
                            this.bookingsPrg = res.data.getRecentBookingsPrognosis;  
                            this.year1 = res.data.base  
                            this.year2 = res.data.target
                            this.year1b = res.data.prevbookings
                            this.year2b = res.data.nowbookings
                            this.perc1 = res.data.percfullyear
                            this.bnow = res.data.thisyearnowbookings
                            this.bprev = res.data.thisyearprevbookings
                            this.perc2 = res.data.percthisyear
                            this.perc3 = res.data.totperc
                            if(param ==='load'){
                                const ctx = document.getElementById('prognose1').getContext('2d');
                                this.chart = new Chart(ctx, this.createBarData(this.bookingsTY, this.bookingsPY, this.bookingsPrg, "bar")); // horizontalBar, bar                                
                            } else {
                                this.refreshChart(this.createBarData(this.bookingsTY, this.bookingsPY, "bar"));
                            }                            
                        }
                    });            
        },
    }        
}    
</script>

<style scoped>

</style>